import { render, staticRenderFns } from "./priceSetPass.vue?vue&type=template&id=5abe3a84&scoped=true"
import script from "./priceSetPass.vue?vue&type=script&lang=js"
export * from "./priceSetPass.vue?vue&type=script&lang=js"
import style0 from "./priceSetPass.vue?vue&type=style&index=0&id=5abe3a84&prod&scoped=true&lang=css"
import style1 from "./priceSetPass.vue?vue&type=style&index=1&id=5abe3a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe3a84",
  null
  
)

export default component.exports